import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SharedService } from "../shared.service";

export interface ProductIntelligenceRequest {
  compId: number;
  fromDate?: string | null;
  toDate?: string | null;
  pageNo?: number;
  pageSize?: number;
  search?: string | null;
}

export interface ProductIntelligenceInsights {
  topScannedProduct: string;
  topScannedCount: number;
  mostTrustedProduct: string;
  mostTrustedRating: number;
  totalCounterfeit: number;
  mostActiveUser: string;
  mostActiveUserCount: number;
  fastestGrowingProduct: string;
  fastestGrowingGrowthPct: number;
  comparedPercentage: number;
  comparePeriodLabel: string;
  currentFromDate: string;
  currentToDate: string;
  previousFromDate: string;
  previousToDate: string;
  trend: "Increase" | "Decrease";
  last30Authentic: number;
  last30AuthenticPercentage: number;
  last30Repeated: number;
  last30RepeatedPercentage: number;
  last30Counterfeit: number;
  last30CounterfeitPercentage: number;
  last30Invalid: number;
  last30InvalidPercentage: number;
  last30Total: number;
}

export interface ProductIntelligenceReportItem {
  rank: number;
  productId: number;
  productName: string;
  productCode: string;
  productImage: string | null;
  totalVerifications: number;
  authenticPercentage: number;
  authenticScans: number;
  repeatedScans: number;
  repeatedPercentage: number;
  duplicateScans: number;
  duplicatePct: number;
  counterfeitAttempts: number;
  counterfeitPercentage: number;
  invalidScans: number;
  invalidPercentage: number;
  productRating: number;
  ratingCount: number;
  growthPercentage: number;
  stateCount: number;
  cityCount: number;
  lastVerifiedDate: string | null;
  topState: string | null;
  topCity: string | null;
  counterfeitHotspot: string | null;
  last30TotalVerifications: number;
  last30AuthenticScans: number;
  last30AuthenticPercentage: number;
  last30RepeatedScans: number;
  last30RepeatedPercentage: number;
  last30CounterfeitAttempts: number;
  last30CounterfeitPercentage: number;
  last30Unverified: number;
  last30UnverifiedPercentage: number;
  totalRows: number;
}

export interface ProductRatingFeedItem {
  productName: string;
  rating: number | null;
  feedback: string | null;
  mobNo: string;
  ratedDt: string;
}

export interface ProductIntelligenceResponse {
  insights: ProductIntelligenceInsights;
  data: ProductIntelligenceReportItem[];
  latestRatings: ProductRatingFeedItem[];
  pageNo: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
}

interface ApiResponse<T> {
  responseCode: string;
  responseMessage: string;
  details: T;
  errorDetails?: string;
}

@Injectable({ providedIn: "root" })
export class ProductIntelligenceService {
  url;

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
  ) {
    this.url = sharedService.baseURL;
  }

  getProductIntelligence(
    request: ProductIntelligenceRequest,
  ): Observable<ProductIntelligenceResponse> {
    return this.http
      .post<
        ApiResponse<ProductIntelligenceResponse>
      >(`${this.url}/api/Home/ProductIntelligence`, request)
      .pipe(map((res) => res.details));
  }
}
